import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { AuthenticationService } from "../../../core/authentication/authentication.service";
import { DataTable } from "../../../shared/components/data-table/data-table.type";
import { UserInfo } from "../../../shared/types/user-info";
import { ConfigurableOptionTableService } from "./configurable-option-table.service";
import { ConfigurableOption } from "./configurable-options.type";

@Component({
  selector: "app-configurable-options",
  templateUrl: "./configurable-options.component.html",
  styleUrls: ["./configurable-options.component.scss"],
})
export class ConfigurableOptionComponent implements OnInit {
  currentUser: UserInfo;
  tableConfig: DataTable<ConfigurableOption>;

  constructor(
    public configurableOptionTableService: ConfigurableOptionTableService,
    private router: Router,
    private authenticationService: AuthenticationService,
  ) {
    this.currentUser = this.authenticationService.currentUserInfo;
  }

  // #region Lifecycle Method

  ngOnInit(): void {
    this.tableConfig = this.configurableOptionTableService.getConfigurableOptionTableConfig();
  }

  // #endregion

  // #region Handlers

  onAddConfigurableOption = (): void => this.addConfigurableOption();

  // #endregion

  // #region Private methods

  private addConfigurableOption = (): void => {
    this.router.navigate(["/configurable-options/create"]);
  };

  // #endregion
}
